// extracted by mini-css-extract-plugin
export default {"container":"SelectSucursal_container__g8OKI"};